module.exports = __webpack_public_path__ + "img/luxio.c193a0c6.png";